/* eslint-disable no-undef */ // eslint is wrong

import { AuthProvider, UserProvider, PortalProvider } from "@zickko/client";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ComposePage } from "./pages/ComposePage";
import { InboxPage } from "./pages/InboxPage";
import { ArchivePage } from "./pages/ArchivePage";
import { emailPortalRoutes } from "./routes/emailPortalRoutes";
import { EmailPortalLayout } from "./layout/EmailPortalLayout";
import { OrgProvider } from "./providers/OrgProvider";
import { OutboxPage } from "./pages/OutboxPage";
import { TrashPage } from "./pages/TrashPage";
import { DraftsPage } from "./pages/DraftsPage";
// TODO:SCSS import "../../../library/client/src/scss/style.scss";

const EmailPortal = () => {
  return (
    <div>
      <Toaster />
      <BrowserRouter>
        <AuthProvider>
          <PortalProvider isAdminPortal={false}>
            <UserProvider>
              <OrgProvider>
                <Routes>
                  <Route path="/" element={<EmailPortalLayout />}>
                    <Route path={emailPortalRoutes.home.template} element={<InboxPage />} />
                    <Route path={emailPortalRoutes.compose.template} element={<ComposePage />} />
                    <Route path={emailPortalRoutes.archive.template} element={<ArchivePage />} />
                    <Route path={emailPortalRoutes.trash.template} element={<TrashPage />} />
                    <Route path={emailPortalRoutes.outbox.template} element={<OutboxPage />} />
                    <Route path={emailPortalRoutes.drafts.template} element={<DraftsPage />} />
                  </Route>
                  {/* Add other routes here */}
                </Routes>
              </OrgProvider>
            </UserProvider>
          </PortalProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
};

createRoot(document.getElementById("app")!).render(<EmailPortal />);
